@for (
    spriteInformationAndLegendStyle of spriteInformationAndLegendStyles();
    track spriteInformationAndLegendStyle.legendStyle.style
) {
    <div class="flex items-center mb-2">
        <div class="flex mr-2">
            <canvas
                #spriteCanvas
                [ngStyle]="spriteInformationAndLegendStyle.legendStyle.style"></canvas>
        </div>
        <span class="text-sm font-medium">
            {{ spriteInformationAndLegendStyle.legendStyle.description || ('notDisclosed' | transloco) }}
        </span>
    </div>
} @empty {
    {{ 'noLegendAvailable' | transloco }}
}
